export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export function isTrue(value: any) {
  if (typeof value === "string" && value.length > 0) {
    value = value.toLowerCase();
  }
  switch (value) {
    case true:
    case "true":
    case 1:
    case "1":
    case "on":
    case "yes":
      return true;
    default:
      return false;
  }
}

export const formatCurrency = (amount: number): string => {
  if (amount === 0) {
    return "$0";
  }
  return currencyFormatter.format(amount);
};

export function hasClass(el: HTMLElement, className: string): boolean {
  return el.classList.contains(className);
}

export function safeInt(value: string | null): number {
  if (value === null) return 0;

  const returnVal = parseInt(value, 10);

  if (isNaN(returnVal)) return 0;

  return returnVal;
}

export function safeString(value: string | null): string {
  if (value === null) return "";
  return value;
}

export const safeReloadPage = () => {
  // eslint-disable-next-line no-self-assign
  window.location.href = window.location.href;
};

export const safeRedirectPage = (url: string) => {
   
  window.location.href = url;
};
